module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG7542c6c27b4a1c08504f12a765fb799f.7542c6c2.png";